// HyperMD, copyright (c) by laobubu
// Distributed under an MIT license: http://laobubu.net/HyperMD/LICENSE
//
// POWERPACK for "addon/fold-emoji"
//
// Use [twemoji](https://github.com/twitter/twemoji) to render emoji `:smile:` :smile:
//
// :warning: **License**:
//
// Please follow https://github.com/twitter/twemoji#license if you use this powerpack.
// 使用前请注意阅读 twemoji 使用许可
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("twemoji"), require("../addon/emoji/index"), require("../addon/fold-emoji")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","twemoji","../addon/emoji/index","../addon/fold-emoji"], mod) :
  /*plain env*/ mod(null, (this.HyperMD_PowerPack = this.HyperMD_PowerPack || {}, this.HyperMD_PowerPack["fold-emoji-with-twemoji"] = {}), twemoji, HyperMD.Emoji, HyperMD.FoldEmoji);
})(function (require, exports, twemoji_1, index_1, fold_emoji_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.twemojiRenderer = exports.twemojiChecker = void 0;
    twemoji_1 = __importDefault(twemoji_1);
    /** twemoji */
    var twemoji = twemoji_1.default || this["twemoji"] || window["twemoji"];
    exports.twemojiChecker = fold_emoji_1.defaultChecker;
    var twemojiRenderer = function (text) {
        var emojiStr = text.startsWith(":")
            ? index_1.EmojiDefinitions[text.replace(/^:(.+?):$/, "$1")]
            : text;
        var twemojiOptions = index_1.getTwemojiOptions();
        var html = twemojiOptions
            ? twemoji.parse(emojiStr, twemojiOptions)
            : twemoji.parse(emojiStr);
        // If twemoji failed to render, fallback to defaultRenderer
        var match = html.match(/^<(img|span) /i);
        if (!match)
            return fold_emoji_1.defaultRenderer(text);
        var attr = /([\w-]+)="(.+?)"/g;
        var ans = document.createElement(match[1] || "img");
        var t;
        while ((t = attr.exec(html)))
            ans.setAttribute(t[1], t[2]);
        return ans;
    };
    exports.twemojiRenderer = twemojiRenderer;
    // Update default EmojiChecker and EmojiRenderer
    if (typeof twemoji !== "undefined") {
        fold_emoji_1.defaultOption.emojiChecker = exports.twemojiChecker;
        fold_emoji_1.defaultOption.emojiRenderer = exports.twemojiRenderer;
    }
    else {
        if (window["ECHOMD_DEBUG"]) {
            console.error("[HyperMD] PowerPack fold-emoji-with-twemoji loaded, but twemoji not found.");
        }
    }
});
